import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { Solution } from '../components/Solution';
import { Deliverables } from '../components/Deliverables';
import { Pricing } from '../components/Pricing';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-text-main selection:bg-primary selection:text-black overflow-x-hidden" data-id="element-178">
      <Hero data-id="element-179" />
      <Problem data-id="element-180" />
      <Solution data-id="element-181" />
      <Deliverables data-id="element-182" />
      <Pricing data-id="element-183" />
      <Footer data-id="element-184" />
    </main>;
}